// extracted by mini-css-extract-plugin
export default {"PickerBody":"IssuesTabPicker_PickerBody__DAwtL","PickerTab":"IssuesTabPicker_PickerTab__RUO6N","SelectedTab":"IssuesTabPicker_SelectedTab__zS3ub"};